import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "sheet", "reportDialog"]

  connect() {
    this.closeOnEscape = this.closeOnEscape.bind(this)
    document.addEventListener("keydown", this.closeOnEscape)
  }

  disconnect() {
    document.removeEventListener("keydown", this.closeOnEscape)
    clearTimeout(this.closeTimer)
    clearTimeout(this.reportCloseTimer)
    this.unlockBody()
  }

  open() {
    clearTimeout(this.closeTimer)
    this.overlayTarget.hidden = false
    this.sheetTarget.hidden = false
    this.lockBody()

    requestAnimationFrame(() => {
      this.element.classList.add("is-open")
    })
  }

  close() {
    if (this.isReportOpen) this.closeReport()

    clearTimeout(this.closeTimer)
    this.element.classList.remove("is-open")
    this.unlockBody()

    this.closeTimer = setTimeout(() => {
      this.overlayTarget.hidden = true
      this.sheetTarget.hidden = true
    }, 240)
  }

  closeOnEscape(event) {
    if (event.key !== "Escape") return

    if (this.isReportOpen) {
      this.closeReport(event)
      return
    }

    if (!this.isOpen) return

    this.close()
  }

  openReport(event) {
    event.preventDefault()

    this.reportForm = event.currentTarget.closest("form")
    this.reportTrigger = event.currentTarget
    clearTimeout(this.reportCloseTimer)
    this.reportDialogTarget.hidden = false

    requestAnimationFrame(() => {
      this.element.classList.add("is-report-open")
      this.reportDialogTarget.querySelector("[data-blog-comments-report-cancel]")?.focus()
    })
  }

  closeReport(event) {
    if (event) event.preventDefault()
    if (!this.hasReportDialogTarget) return

    clearTimeout(this.reportCloseTimer)
    this.element.classList.remove("is-report-open")

    this.reportCloseTimer = setTimeout(() => {
      this.reportDialogTarget.hidden = true
    }, 180)

    this.reportTrigger?.focus()
    this.reportForm = null
    this.reportTrigger = null
  }

  closeReportOnBackdrop(event) {
    if (event.target === this.reportDialogTarget) this.closeReport(event)
  }

  submitReport(event) {
    event.preventDefault()

    const form = this.reportForm
    if (!form) return

    this.reportForm = null
    this.reportTrigger = null
    this.element.classList.remove("is-report-open")
    this.reportDialogTarget.hidden = true

    if (form.requestSubmit) {
      form.requestSubmit()
    } else {
      form.submit()
    }
  }

  get isOpen() {
    return this.element.classList.contains("is-open")
  }

  get isReportOpen() {
    return this.element.classList.contains("is-report-open")
  }

  lockBody() {
    if (document.body.classList.contains("blog-sheet-open")) return

    this.scrollY = window.scrollY
    document.body.classList.add("blog-sheet-open")
    document.body.style.position = "fixed"
    document.body.style.top = `-${this.scrollY}px`
    document.body.style.left = "0"
    document.body.style.right = "0"
    document.body.style.width = "100%"
  }

  unlockBody() {
    if (!document.body.classList.contains("blog-sheet-open")) return

    document.body.classList.remove("blog-sheet-open")
    document.body.style.position = ""
    document.body.style.top = ""
    document.body.style.left = ""
    document.body.style.right = ""
    document.body.style.width = ""
    window.scrollTo(0, this.scrollY || 0)
  }
}
